var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appStudy_line",attrs:{"id":"appStudy_line"}})
}
var staticRenderFns = []

export { render, staticRenderFns }